module.exports = __webpack_public_path__ + "img/6.17fd13f4.jpg";